// utils/dateUtils.js

// Function to calculate time elapsed since a date
export const getTimeElapsed = (dateString) => {
    const creationDate = new Date(dateString);
    const now = new Date();
    const diffInMs = now - creationDate;

    // Conversione in diverse unità di tempo
    const seconds = Math.floor(diffInMs / 1000);
    const minutes = Math.floor(diffInMs / (1000 * 60));
    const hours = Math.floor(diffInMs / (1000 * 60 * 60));
    const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (years > 0) {
        return `${years} ${years === 1 ? 'anno' : 'anni'} fa`;
    } else if (months > 0) {
        return `${months} ${months === 1 ? 'mese' : 'mesi'} fa`;
    } else if (weeks > 0) {
        return `${weeks} ${weeks === 1 ? 'settimana' : 'settimane'} fa`;
    } else if (days > 0) {
        return `${days} ${days === 1 ? 'giorno' : 'giorni'} fa`;
    } else if (hours > 0) {
        return `${hours} ${hours === 1 ? 'ora' : 'ore'} fa`;
    } else if (minutes > 0) {
        const remainingSeconds = seconds % 60;
        return `${minutes} ${minutes === 1 ? 'minuto' : 'minuti'} e ${remainingSeconds} ${remainingSeconds === 1 ? 'secondo' : 'secondi'} fa`;
    } else {
        return `${seconds} ${seconds === 1 ? 'secondo' : 'secondi'} fa`;
    }
};


// Function to format subscription period
export const formatSubscriptionPeriod = (start, end) => {
    const formatDate = (isoString) => {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Mese da 0 a 11
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    try {
        const formattedStart = formatDate(start);
        const formattedEnd = formatDate(end);

        return `Dal ${formattedStart} al ${formattedEnd}`;
    } catch (error) {
        console.error("Errore nella formattazione delle date:", error);
        return "Periodo non disponibile";
    }
};

export const getCountdownFrom72Hours = (dateString) => {
    // Converti la stringa della data in oggetto Date
    const startDate = new Date(dateString);

    // Calcola la data di scadenza (72 ore dopo la data di partenza)
    const expiryDate = new Date(startDate.getTime() + 72 * 60 * 60 * 1000);

    // Data corrente
    const currentDate = new Date();

    // Se la data corrente è oltre la data di scadenza, restituisci false
    if (currentDate > expiryDate) {
        return false;
    }

    // Calcola il tempo rimanente in millisecondi
    const remainingTime = expiryDate - currentDate;

    // Converti in ore, minuti e secondi
    const hours = Math.floor(remainingTime / (1000 * 60 * 60));
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

    // Formatta il tempo rimanente come stringa (hh:mm:ss)
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

export const getTimeLeftLabel = (endDateStr) => {
    const endDate = new Date(endDateStr);
    const now = new Date();
  
    // Normalizza alle 00:00 per confronto preciso
    endDate.setHours(0, 0, 0, 0);
    now.setHours(0, 0, 0, 0);
  
    const diffTime = endDate.getTime() - now.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
    if (diffDays < 1) return "meno di 1 giorno";
    if (diffDays === 1) return "1 giorno";
    if (diffDays < 7) return `${diffDays} giorni`;
  
    const weeks = Math.floor(diffDays / 7);
  
    if (weeks < 4) {
      if (weeks === 1) return "questa settimana";
      if (weeks === 2) return "due settimane";
      return `${weeks} settimane`;
    }
  
    const months = Math.floor(weeks / 4);
    const leftoverWeeks = weeks % 4;
  
    if (leftoverWeeks === 0) {
      return months === 1 ? "1 mese" : `${months} mesi`;
    }
  
    const monthLabel = months === 1 ? "1 mese" : `${months} mesi`;
    const weekLabel = leftoverWeeks === 1 ? "1 settimana" : `${leftoverWeeks} settimane`;
  
    return `${monthLabel} e ${weekLabel}`;
  };